import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MenuController } from '@ionic/angular';
import { AlertService } from '../../../services/alert.service';
//import { BrandService } from '../../services/brand.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
//import { MenuConfig } from '../../types/MenuConfig';
//import { VersionService } from '../../services/version.service';
import { Capacitor } from '@capacitor/core';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss', '../authentication.scss']
})
export class LoginPage implements OnInit, OnDestroy {

  title = 'Login';
  loginForm: FormGroup;

  appVersion: string;
  buildVersion: string = "1";
  environment: string = "dev";
  //theme: string;

  phoneNumber: string = '';

  @ViewChild('phoneNumberInput', { static: true, read: ElementRef })
  phoneNumberEl!: ElementRef;

  errorMessage: string = '';

  displayEnv: boolean;

  private phoneValueSub?: Subscription;

  CountryIso = CountryISO;
  SearchCountryField = SearchCountryField;

  constructor(
    private router: Router,
    private menuCtrl: MenuController,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    //private versionService: VersionService,
    //public brandService: BrandService,
    private amplifyAppService: AuthService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
  ) {
    this.menuCtrl.enable(false, 'left');
    this.menuCtrl.enable(false, 'right');
    this.docTitle.setTitle(this.title);
    this.loginForm = this.formBuilder.group({
      phone: ['', [Validators.required]],
    });
    this.appVersion = "3.0"; // this.versionService.getAppVersion();
    // this.registeredPhoneNumber = this.navParams.get('registeredPhoneNumber');
    this.displayEnv = false;
    this.analyticsService.tagRoute('unauthenticated/login');
  }

  ngOnInit() {
    this.phoneValueSub = this.loginForm.controls['phone'].valueChanges.subscribe(value => {
      this.setPhoneNumber(value);
    });
  }

  ngOnDestroy() {
    this.phoneValueSub?.unsubscribe();
  }

  ionViewDidEnter() {
    this.loginForm.updateValueAndValidity();
    // This is to update the country code if it exists in the input
    if (this.phoneNumberEl?.nativeElement) {
      this.phoneNumberEl.nativeElement.dispatchEvent(new Event('keyup'));
    }
  }

  verifyLogin() {
    this.analyticsService.tagButtonPress('login_page', 'verifylogin');
    const intlNumber = this.phoneNumber;
    if (Capacitor.isNativePlatform() && this.isDemoUser()) {
      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: intlNumber }});
    } else if (intlNumber) {
      this.sendCode(intlNumber);
    }
  }

  goToContactUs() {
    this.analyticsService.tagButtonPress('login_page', 'contactus');
    this.router.navigate(['unauthenticated', 'contactus']);
  }

  async sendCode(phoneNumber: string) {
    try {
      if (Capacitor.isNativePlatform()) {
        await this.amplifyAppService.sendForgotPasswordCode(phoneNumber);
      } else {
        this.amplifyAppService.sendCustomAuthSmsCode(phoneNumber);
      }

      // this.toastService.show(`We sent a SMS to ${phoneNumber} with a code, please enter it here.`);

      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: phoneNumber }});
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError(error: any) {
    console.error('Login: Code', error);
    if (this.amplifyAppService.isInvalidParameterException(error)) {
      // this is an educated guess that the user is in an UNCONFIRMED state
      // and needs a signUpCode instead of a forgotPasswordCode
      this.sendSignUpCode(this.phoneNumber);
    } else if (this.amplifyAppService.isUserNotFoundException(error)) {
      this.handleUserNotFoundAlert();
    } else {
      this.alertService.showAmplifyAuthError(error);
    }
  }

  handleUserNotFoundAlert() {
    this.alertService.confirm(
      `This mobile number is not registered`,
      `Would you like to register?`,
      `Register`,
      () => { this.goToRegister(); });
  }

  sendSignUpCode(phone: string) {
    this.amplifyAppService.resendSignUpCode(phone)
      .then(() => {
        this.toastService.show(`We sent a SMS to ${phone} with a code, please enter it here.`);
        this.router.navigate(['../VerifySignUpPage'], { queryParams: { phone: phone }, relativeTo: this.activatedRoute });
      })
      .catch((error: any) => {
        this.alertService.showAmplifyAuthError(error);
        console.error('sendSignUpCode:', error);
      });
  }


  setPhoneNumber($event: any) {
    if ($event) {
      this.phoneNumber = $event.e164Number ?? $event.internationalNumber ?? '';
    } else {
      this.phoneNumber = '';
    }
    this.setErrorMessage(this.phoneNumber);
  }

  setErrorMessage(phoneNumber: string) {
    if (!Boolean(phoneNumber)) {
      this.errorMessage = 'Mobile number is required';
    } else if (!this.loginForm.valid) {
      this.errorMessage = 'Mobile number is not valid';
    } else {
      this.errorMessage = '';
    }
  }

  goToRegister() {
    this.router.navigate(['unauthenticated', 'siteCodeEntry']);
  }

  isDemoUser() {
    return (this.phoneNumber ?? '').endsWith('000000');
  }

  toggleEnvText() {
    if (this.environment !== 'prod') {
      this.displayEnv = !this.displayEnv;
    }
  }

  /*changeTheme(theme: string) {
    this.brandService.set(theme);
  }*/

}
